import { gql } from '@/utilities/gql';
import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';
import { NARRATIVE_CARD_OPTION_FRAGMENT } from '../components/NarrativeCardOption';

const QUERY = gql(
  `
  query NarrativeFairValueModalGetNarrativeValuationOptions($companyId: ID!, $communityLimit: Int) {
    company(ref: $companyId) {
      tickerSymbol
      valuationOptions(communityLimit: $communityLimit) {
        ...NarrativeCardOptionValuationOptionFields
      }
    }
  }
`,
  [NARRATIVE_CARD_OPTION_FRAGMENT]
);

export const useNarrativeValuationOptions = makeGqlSuspenseQuery(QUERY, {
  tags: ['narrative', 'narrative-valuation-options'],
});
